import React from 'react'
import {
    FormControl,
    FormControlLabel,
    Checkbox,
    FormGroup,
} from '@material-ui/core'
import useMainContext from '../../../hooks/useMainContext'

export default function PickupOptions({ visible, pickup = false, setPickup, disabled }) {
    const { config } = useMainContext()

    if (!visible)
        return <></>


    return (
        <FormControl component="fieldset" disabled={disabled}>
            <FormGroup>
                <FormControlLabel
                    label={`Retiro en local ${config?.pickupDiscount && `(${config?.pickupDiscount}% de descuento)`}`}
                    control={
                        <Checkbox
                            checked={pickup}
                            onChange={() => setPickup(!pickup)}
                            name="pickup"
                            color="primary"
                            disabled={disabled}
                        />
                    }
                />
            </FormGroup>
        </FormControl>

    )
}
